const topicItems = [
  { id: 1, name: '不缓冲秒开', count: 12800, icon: 'ri-flashlight-line' },
  { id: 2, name: '4K超清画质', count: 9600, icon: 'ri-4k-line' },
  { id: 3, name: '科幻电影', count: 8750, icon: 'ri-rocket-line' },
  { id: 4, name: '诺兰导演', count: 7200, icon: 'ri-user-star-line' },
  { id: 5, name: '经典修复', count: 6900, icon: 'ri-vip-crown-line' },
  { id: 6, name: '动作大片', count: 8450, icon: 'ri-fire-line' },
  { id: 7, name: '悬疑烧脑', count: 6100, icon: 'ri-lightbulb-line' },
  { id: 8, name: '华语佳片', count: 7800, icon: 'ri-china-railway-line' },
  { id: 9, name: '动画电影', count: 5600, icon: 'ri-palette-line' },
  { id: 10, name: '高分推荐', count: 9300, icon: 'ri-thumb-up-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            影迷们正在热烈讨论的热点内容，看看大家都在关注什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <a
              key={item.id}
              href="#topics"
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-100/80 rounded-full border border-background-200/50 hover:border-primary-500/30 hover:bg-background-200/60 transition-all duration-200 group cursor-pointer no-underline"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={`${item.icon} text-primary-500 text-sm group-hover:text-primary-400 transition-colors`}></i>
              </span>
              <span className="text-sm text-foreground-300 group-hover:text-foreground-200 transition-colors whitespace-nowrap">
                {item.name}
              </span>
              <span className="text-xs text-foreground-600 bg-background-300/40 px-1.5 py-0.5 rounded whitespace-nowrap">
                {item.count.toLocaleString()}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}